import { MapContainer, TileLayer, LayersControl } from "react-leaflet";
import { FullscreenControl } from "./FullScreen";
import { RoutingLocation } from "./RoutingLocation";

const { BaseLayer } = LayersControl;

export const MapView = ({ children, center, routes }) => {
  return (
    <MapContainer
      center={center || [-6.200000, 106.816666]}
      zoom={13}
      maxZoom={20} 
      style={{ height: "100%", width: "100%", minHeight: "300px", zIndex: 0 }}
      className="relative w-full h-full z-0"
    >
      <LayersControl position="topright">
        
        {/* ==================== GOOGLE MAPS ==================== */}
        
        {/* 1. Google Standard (Roadmap) */}
        <BaseLayer checked name="Google Maps">
          <TileLayer
            attribution='&copy; Google Maps'
            url="https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
            subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
            maxZoom={20}
          maxNativeZoom={20}
          />
        </BaseLayer>

        {/* 2. Google Satellite */}
        <BaseLayer name="Google Satellite">
          <TileLayer
            attribution='&copy; Google Maps'
            url="https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}"
            subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
            maxZoom={20}
            maxNativeZoom={20}
          />
        </BaseLayer>

        {/* 3. Google Hybrid (Satellite + Labels) */}
        {/* <BaseLayer name="Google Hybrid">
          <TileLayer
            attribution='&copy; Google Maps'
            url="https://{s}.google.com/vt/lyrs=y,h&x={x}&y={y}&z={z}"
            subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
            maxZoom={20}
            maxNativeZoom={20}
          />
        </BaseLayer> */}

        {/* 4. Google Terrain */}
        {/* <BaseLayer name="Google Terrain">
          <TileLayer
            attribution='&copy; Google Maps'
            url="https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}"
            subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
            maxZoom={20}
            maxNativeZoom={20}
          />
        </BaseLayer> */}

        {/* ==================== CARTODB (Bagus untuk Dark Theme) ==================== */}
        
        {/* 5. CartoDB Dark (Cocok untuk dashboard Anda) */}
        {/* <BaseLayer name="CartoDB Dark">
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
            url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
            subdomains={['a', 'b', 'c', 'd']}
            maxZoom={20}
          />
        </BaseLayer> */}

        {/* 6. CartoDB Voyager (Clean & Modern) */}
        {/* <BaseLayer name="CartoDB Voyager">
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
            url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
            subdomains={['a', 'b', 'c', 'd']}
            maxZoom={20}
          />
        </BaseLayer> */}

        {/* ==================== OPENSTREETMAP ==================== */}
        
        {/* 7. OpenStreetMap Standard */}
        <BaseLayer name="OpenStreetMap">
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            maxZoom={20}
            maxNativeZoom={19}
          />
        </BaseLayer>

      </LayersControl>

      {/* === RENDER ROUTES === */}
      {routes && Array.isArray(routes) && routes.map((route, index) => (
        <RoutingLocation 
          key={`route-${index}`} 
          from={route.from}
          to={route.to}
          iconFrom={route.iconFrom}
          iconTo={route.iconTo}
          popupFrom={route.popupFrom}
          popupTo={route.popupTo}
          lineColor={route.lineColor} 
        />
      ))}

        <FullscreenControl />

      {children}
    </MapContainer>
  );
};